import React from 'react';
import TableExportActions from './TableExportActions';
import MapExportActions from './MapExportActions';
import './ExportActions.css';

const ExportActions = ({
  selectedView, selectedLocation, popupOpen, onMenuStateChange,
  activeTab, hasPreviousData, isInsideMapContainer, locationName,
  exportContext, exportContextRef, userPlan, onRequestUpgrade,
}) => {
  if (selectedView === 'map' && isInsideMapContainer) {
    return <MapExportActions 
      selectedLocation={selectedLocation} 
      popupOpen={popupOpen} 
      onMenuStateChange={onMenuStateChange}
      activeTab={activeTab} 
      hasPreviousData={hasPreviousData}
      locationName={locationName}
      exportContext={exportContext}
      exportContextRef={exportContextRef}
      userPlan={userPlan}
      onRequestUpgrade={onRequestUpgrade}
    />;
  }
  return (
    <TableExportActions
      locationName={locationName}
      exportContext={exportContext}
      userPlan={userPlan}
      onRequestUpgrade={onRequestUpgrade}
    />
  );
};

export default ExportActions;
